export class GoogleCredentialInfo {
  private token: any;
  private jwt: string;

  constructor(token: any, jwt: string) {
    this.token = token;
    this.jwt = jwt;
  }

  getId(): string {
    return this.token.jti;
  }

  getName(): string {
    return this.token.name;
  }

  getGivenName(): string {
    return this.token.given_name ;
  }

  getFamilyName(): string {
    return this.token.family_name;
  }

  getImageUrl(): string {
    return this.token.picture;
  }

  getEmail(): string {
    return this.token.email;
  }

  getJwt(): string {
    return this.jwt;
  }
}